module.exports = __webpack_public_path__ + "static/media/testImage.4916e328.png";